// src/form-component/FormInputText.tsx
import { Controller, FieldValues, RegisterOptions } from "react-hook-form"
import TextField from "@mui/material/TextField"
import { useTheme } from "@mui/material/styles"

export interface FormInputNumberProps {
  name: string
  control: any
  label: string
  spacing: number
  customOnChange?: (event: any) => void | undefined
  rules?:
    | Omit<
        RegisterOptions<FieldValues, string>,
        "valueAsNumber" | "valueAsDate" | "setValueAs" | "disabled"
      >
    | undefined
}

const FormInputNumber: React.FC<FormInputNumberProps> = ({
  name,
  control,
  label,
  spacing,
  customOnChange,
  rules,
}) => {
  const theme = useTheme()

  return (
    <div
      style={{
        marginTop: theme.spacing(spacing),
        marginBottom: theme.spacing(spacing),
        maxWidth: "100%",
      }}
    >
      <Controller
        name={name}
        control={control}
        rules={rules}
        render={({ field: { onChange, value }, fieldState: { error } }) => (
          <TextField
            helperText={error ? error.message : null}            
            size="small"
            error={!!error}
            type="number"
            onChange={(e) => {
              if (customOnChange) {
                customOnChange(e)
              }
              onChange(e)
            }}
            value={value}
            fullWidth
            label={label}
            variant="outlined"
          />
        )}
      />
    </div>
  )
}

export default FormInputNumber
